import Button from '@/features/ui/buttons/components/Button'
import { FC, memo } from 'react'
import { useTranslation } from 'react-i18next'
import { StyleSheet } from 'react-native'

interface CancelButtonProps {
    disabled?: boolean
    onPress: () => void
    label?: string
}

const CancelButton: FC<CancelButtonProps> = ({ disabled, onPress, label }) => {
    const { t } = useTranslation()

    return (
        <Button
            disabled={disabled}
            type="outline"
            color="secondary"
            onPress={onPress}
            textStyle={styles.buttonText}
            style={styles.button}
        >
            {label ?? t('actions.cancel')}
        </Button>
    )
}

const styles = StyleSheet.create({
    button: {
        flexGrow: 1,
        justifyContent: 'center',
    },
    buttonText: {
        textTransform: 'uppercase',
    },
})

export default memo(CancelButton)
